import axios from 'axios'
import modulesDriversLoader from '../services/ModulesDriversLoader'

export default class DivisionManagementService {
    constructor() {
        modulesDriversLoader.load().then(({ getApiRoutes }) => {
            this.apiRotues = { ...getApiRoutes() }
        })
    }

    async fetchLegalDivisionsList(entityId, params = {}) {
        const response = await axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/division/legal_entity/${entityId}/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || []
    }

    async fetchInstituteDivisionsList(divisionId, params = {}) {
        const response = await axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/division/institute/${divisionId}/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || []
    }

    async create(payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/division/add`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }

    async delete(divisionId) {
        const response = await axios.delete(
            `${this.apiRotues.API_BASE_URL}/entity_management/division/remove/${divisionId}`,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }

    async edit(divisionId, payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/division/edit/${divisionId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }
}
